import { datadogLogs } from '@datadog/browser-logs';

import { initDatadogLogs } from '../datadog';
import rollbarHelper, {
  initRollbarSdk,
  LOG_LEVELS,
  updateRollbarAnonymousId,
} from '../rollbar/rollbarHelper';

// Re-export LOG_LEVELS from rollbarHelper
export { LOG_LEVELS } from '../rollbar/rollbarHelper';

// Re-export the updateRollbarAnonymousId function
export const updateAnonymousId = anonymousId => {
  updateRollbarAnonymousId(anonymousId);
};

// Re-export the initRollbarSdk function
export const initLogging = () => {
  initRollbarSdk();
  initDatadogLogs();
};

/**
 * Initiates a log request
 * @param {Object} log
 */
export const loggerHelper = ({ consoleOnly, level, message, info }) => {
  if (consoleOnly) {
    // eslint-disable-next-line no-console
    console.warn(message, info);
    return;
  }

  // rollbar
  rollbarHelper({
    level,
    message,
    info,
  });

  // datadog
  switch (level) {
    case LOG_LEVELS.ERROR:
      datadogLogs.logger.error(message, info, new Error(message));
      break;
    case LOG_LEVELS.WARNING:
      datadogLogs.logger.warn(message, info);
      break;
    case LOG_LEVELS.INFO:
      datadogLogs.logger.info(message, info);
      break;
    case LOG_LEVELS.DEBUG:
      datadogLogs.logger.debug(message, info);
      break;
    default:
      datadogLogs.logger.error(message, info, new Error(message));
      break;
  }
};

export default loggerHelper;
